import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { tokens } from "../api/client.ts";

export default function SsoCallbackPage() {
  const nav = useNavigate();
  useEffect(() => {
    const fragment = window.location.hash.replace(/^#/, "");
    const params = new URLSearchParams(fragment);
    const access = params.get("access_token");
    const refresh = params.get("refresh_token");
    if (access && refresh) {
      tokens.set({ access_token: access, refresh_token: refresh, expires_in: 0 });
      nav("/dashboard", { replace: true });
    } else {
      nav("/login?sso_error=1", { replace: true });
    }
  }, [nav]);
  return <div className="grid min-h-screen place-items-center text-sm text-slate-500">Signing you in…</div>;
}
